import { Color } from '@drawbotics/react-drylus';

export enum TargetDomain {
  MOSAIC = 'mosaic',
  DRAWBOTICS = 'drawbotics',
}

export enum AuthFlow {
  SIGN_IN = 'SIGN_IN',
  SIGN_UP = 'SIGN_UP',
}

export enum LocaleCode {
  EN = 'en',
  FR = 'fr',
  NL = 'nl',
}

export interface AppContext {
  env: {
    AUTH_HOST: string;
    GOOGLE_CLIENT_ID: string;
    AZURE_CLIENT_ID: string;
  };
  targetDomain: TargetDomain;
  color: Color;
  onFinish: VoidFunction;
}

export type UserSignupFormValue = {
  email: string;
  password: string;
  first_name: string;
  last_name: string;
  locale: LocaleCode;
};

export interface Organization {
  id: string;
  name: string;
}

export interface User {
  id: string;
  exp: number;
  confirmed: boolean;
  organization: Organization;
  locale: LocaleCode;
  email: string;
}

export interface UserFromToken {
  id: string;
  exp: number;
  confirmed: boolean;
  role: 'admin' | 'member';
  organisation: Organization;
  locale: LocaleCode;
  email: string;
}

export enum InvitationStatus {
  INITIATED = 'initiated',
  SENT = 'sent',
  ACCEPTED = 'accepted',
}

export type Invitation = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  status: InvitationStatus;
  organisationName: string;
  organisationId: string;
  token: string;
};
